export default {
  CLIENTS_LIST: "Application List",
  ADD_CLIENT: "Add Application",
  CLIENT_ADDED: "Application Added",
  CLIENTS_UPDATED: "Application Updated",
  EDIT_CLIENT: "Edit Application",
  DELETE_THIS_CLIENT: "Delete this Application?",
  CLIENT_DELETED: "Application Deleted",
  VIEW_CLIENT: "View Application",
  NONE: "None",
};
